import React from 'react';
import { useDispatch } from 'react-redux';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import { triggerOnboardingAcquisitionClicked } from 'core/modules/Onboarding/actions';

import './OnboardingAcquisition.scss';

function OnboardingAcquisition({ handleAcquisitionDoneClick, sequenceValue }) {
  const dispatch = useDispatch();

  const onNextClick = () => {
    dispatch(triggerOnboardingAcquisitionClicked('Clicked next'));
    handleAcquisitionDoneClick();
  };

  return (
    <div className="mn_onboardingAcquisition">
      <div className="mn_brandLogo mn_bonusaqsScreenLogo" />
      <h3 className="mn_bonush3">NEW MEMBER BONUS</h3>
      <h2 className="mn_bonush2">Earn 1,000 bonus miles for a limited time</h2>
      <p className="mn_bonusPara">
        As a United Airlines MileagePlus Shopping<sup>SM</sup> Cardmember,
        you'll earn 1,000 bonus miles when you spend $25 within the first two weeks of signing up.<sup>*</sup>
      </p>
      <button
        className="mn_stepButton mn_button"
        onClick={() => onNextClick()}
        data-sequence-value={sequenceValue}
      >
        Next
      </button>
      <p className="mn_bonusTerms">
        *MileagePlus Credit Card Members will receive one thousand (1000) MileagePlus miles ("Bonus Awards Miles")
        when they make qualifying purchase(s) through MileagePlus Shopping<sup>SM</sup> totaling $25.00 or more.
        Member must login and make the qualifying purchase(s) through the Site during the Bonus Period.
        Please allow 6-8 weeks for Bonus Award Miles to post to your MileagePlus Shopping account.
        "Qualifying purchases" do not include product returns or cancellations, gift card purchases,
        and certain products identified by the individual merchant.
        Individual merchants may have additional terms and conditions on their store details page on the Site,
        which terms and conditions will apply to this Bonus Offer.
        Each new MileagePlus Shopping mall account is eligible for a maximum of one (1) Bonus Award Miles reward.
        All MileagePlus Shopping program rules and regulations apply. Void where prohibited by law.
      </p>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><OnboardingAcquisition {...props} /></ComponentErrorBoundary>;
